import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {markAsShippedBox, markAsShippedBoxs} from "../../../services/api/apiNextBox"
import { message, Modal, Progress, Button } from 'antd'
import { ExclamationCircleOutlined, CheckCircleOutlined, WarningOutlined } from '@ant-design/icons'


class MarkAsShippedBox extends Component {
    state = {
        box_number: '',
        listBoxScan: [],
        loading: false,
        listSuccess: [],
        listError: [],
        listIgnore: [],
        modalVisable: false,
    }

    textInput = React.createRef()

    _handleChange = e => {
        const {value} = e.target

        this.setState({
            box_number: value,
        })
    }

    _handleAfterSubmit = () => {
        this.props.onRefresh()
        this.textInput.current.focus()
    }

    _handleSubmit = async e => {
        e.preventDefault()

        if (this.state.loading) return true

        this.setState({
            loading: true,
        })

        console.log('Submit box as shipped', this.state.box_number)
        const {box_number} = this.state
        const listBox = [...new Set(box_number.replace(/#| /g, ',').split(',').filter(i => !!i))]
        if (box_number.includes(',') && listBox.length > 1) {
            const payload = {}
            if (listBox.length > 1 && listBox.length <= 10) payload.box_ids = listBox
            
            try {
                if (listBox.length > 10) throw new Error('Giới hạn mỗi lần đánh dấu ship là 10 thùng!')
                
                const {success, data: res, message: mess } = await markAsShippedBoxs(payload)
                if (!success) {
                    throw new Error(mess)
                }
                const listSuccess = res.data.filter(i => !!i.success && !i.ignore)
                const listError = res.data.filter(i => !i.success && !i.ignore)
                const listIgnore = res.data.filter(i=> !!i.ignore)
                this.setState({
                    loading: false,
                    box_number: '',
                    listSuccess: listSuccess,
                    listError: listError,
                    listIgnore: listIgnore,
                }, this._handleAfterSubmit)
                this._handleShowModal()
            } catch (err) {
                window.alert(err.message)

                this.setState({ loading: false, box_number: '' }, this._handleAfterSubmit)
            }
        } else {
            const vBoxNumber = (box_number || '').replace(/#|,/g, '').trim()

            try {
                const { success, message: mess } = await markAsShippedBox(listBox[0])

                if (!success) {
                    throw new Error(mess)
                }
                message.success(`Thùng #${vBoxNumber} đã được đánh dấu ship thành công!`)
                this.setState({ loading: false, box_number: '' }, this._handleAfterSubmit)

            } catch (err) {
                window.alert(err.message)

                this.setState({ loading: false, box_number: '' }, this._handleAfterSubmit)
            }
        }
    }

    _handleCancelModal = () => {
        this.setState({
            modalVisable:false,
            listSuccess: [],
            listError: [],
        })
    }
    _handleShowModal = () => {
        this.setState({modalVisable:true})
    }

    render() {
        const {loading, box_number, modalVisable, listSuccess, listError, listIgnore} = this.state
        const totalMarkShip = listSuccess.length + listError.length + listIgnore.length

        return (
            <div className="MarkAsShippedBox mr-3 mb-2">
                <form onSubmit={this._handleSubmit} className="Form">
                    <input onChange={this._handleChange}
                           ref={this.textInput}
                           readOnly={loading}
                           disabled={loading}
                           value={box_number}
                           className="form-control" type="text"
                           placeholder="Quét QR để đánh dấu ship"/>
                </form>
                <Modal
                    title="Kết quả đánh dấu ship"
                    visible={modalVisable}
                    onCancel={this._handleCancelModal}
                    footer={<Button onClick={this._handleCancelModal}>Đóng</Button>}
                >
                    <h6 className='font-weight-bold'>Tổng số thùng đánh dấu ship: <span>{totalMarkShip}</span> thùng</h6>
                    {
                        (listSuccess.length > 0 || listError.length > 0) &&
                        <div className="Results d-flex align-items-center">
                            <div className="ResultSuccess mr-2">
                                Success: <span className='text-success font-weight-bold'>{listSuccess.length}</span> thùng
                            </div>
                            <div className="ResultError mr-2">
                                Error: <span className='text-danger font-weight-bold'>{listError.length}</span> thùng
                            </div>
                            <div className="ResultShipped">
                                Shipped: <span className='text-warning font-weight-bold'>{listIgnore.length}</span> thùng
                            </div>
                        </div>
                    }
                    <div className="ListProcessing">
                        <ul>
                            {!!listSuccess && listSuccess.length > 0 && listSuccess.map(item => (
                                <li key={item._id}>
                                    <span className='mr-2 font-weight-bold'>#{item.box_id}</span>
                                    {
                                        !!item.success && !item.ignore &&
                                        <span className="Success text-success"><CheckCircleOutlined /> Đánh dấu ship thành công</span>
                                    }
                                    <Progress
                                        percent={100}
                                        size="small"
                                        status='success'
                                        showInfo={false}
                                    />
                                </li>
                            ))}
                            {!!listError && listError.length > 0 && listError.map(item => (
                                <li key={item._id}>
                                    <span className='mr-2 font-weight-bold'>#{item.box_id}</span>
                                    {
                                        !!item.error && !item.ignore &&
                                        <span className="Error text-danger"><ExclamationCircleOutlined /> {item.error}</span>
                                    }
                                    <Progress
                                        percent={100}
                                        size="small"
                                        status='exception'
                                        showInfo={false}
                                    />
                                </li>
                            ))}
                            {!!listIgnore && listIgnore.length > 0 && listIgnore.map(item => (
                                <li key={item._id}>
                                    <span className='mr-2 font-weight-bold'>#{item.box_id}</span>
                                    {
                                        !!item.ignore &&
                                        <span className="Error text-warning"><WarningOutlined /> {item.message}</span>
                                    }
                                    <Progress
                                        percent={100}
                                        size="small"
                                        status='exception'
                                        strokeColor={'orange'}
                                        showInfo={false}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </Modal>
            </div>
        )
    }
}

MarkAsShippedBox.propTypes = {
    onRefresh: PropTypes.func.isRequired,
}

export default MarkAsShippedBox
